import { ReactComponent as Linkedin } from 'assets/icons/icon-linkedin.svg';

export default Linkedin;
